import React from "react";
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import logo from "../assets/Final-logo.png";

const FooterBox = styled("footer")(() => ({
  backgroundColor: "#fff",
  color: "#000",
  padding: "40px 20px",
  marginTop: "50px",
  borderTop: "1px solid #ddd",
}));

export default function Footer() {
  return (
    <FooterBox>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "center", md: "flex-start" },
            gap: 4,
          }}
        >

          {/* LEFT - LOGO */}
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <img
              src={logo}
              alt="Matrimony Logo"
              style={{
                width: "120px",
                height: "auto",
                marginBottom: "10px",
              }}
            />
          </Box>

          {/* MIDDLE - QUICK LINKS */}
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography
              variant="h6"
              sx={{ mb: 1, fontFamily: "Quicksand", fontWeight: 600 }}
            >
              Quick Links
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
              <Link style={{ textDecoration: "none", color: "#000", fontFamily:"quicksand" }} to="/">
                Home
              </Link>
              <Link style={{ textDecoration: "none", color: "#000",fontFamily:"quicksand" }} to="/about-us">
                About Us
              </Link>
              <Link style={{ textDecoration: "none", color: "#000",fontFamily:"quicksand" }} to="/contact-us">
                Contact Us
              </Link>
            </Box>
          </Box>

          {/* RIGHT - CONTACT DETAILS */}
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography
              variant="h6"
              sx={{ mb: 1, fontFamily: "Quicksand", fontWeight: 600 }}
            >
              Contact Us
            </Typography>
            <Typography>Phone: +91 9962008680, +91 8903791212</Typography>
            <Typography>
              No.5/26, 58th Street, Ashok Nagar, Chennai - 600083
              (Near Aachi Kitchen)
            </Typography>
          </Box>

        </Box>

        {/* BOTTOM COPYRIGHT */}
        <Typography
          sx={{
            mt: 3,
            opacity: 0.7,
            fontSize: "0.85rem",
            textAlign: "center",
          }}
        >
          © 2025 Vivaha Sangamam. All rights reserved.
        </Typography>
      </Container>
    </FooterBox>
  );
}
